<template>
  <!-- <v-card
    class="mx-auto start-card"
    max-width="400"
    color="#EEEEFF"
  > -->
  <div id="game-description" class="my-4">
    <v-card
      class="mx-auto"
      width="400"
      color="rgba(0,0,0,0)"
      elevation=0
      @mouseover="mouseover"
      @mouseleave="mouseleave"
    >
      <p v-if="selected!='description'&&changeHover" style="font-size:20px;background-color:rgba(0,0,0,0.1);color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>ゲームの説明</b></p>
      <p v-else-if="selected!='description'" style="font-size:20px;color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>ゲームの説明</b></p>
      <p v-else style="background-color:rgba(0,0,0,0.2);font-size:20px;color:#FFFFFF;"><b>ゲームの説明</b></p>
    </v-card>
    <v-expand-transition>
      <v-card
        v-if="selected=='description'"
        class="mx-auto mt-n4"
        elevation=0
        width="400"
        color="rgba(0,0,0,0.2)"
      >
        <div class="mx-auto my-auto" style="width:360px; padding: 12px 0">
          <!-- <v-simple-table dark> -->
            <template>
              <tbody>
                <tr>
                  <td style="width:100px"><p><b>説明</b></p></td>
                  <td style="text-align:left"><p>レジスタンス(ボードゲーム)をオンラインで遊べます。</p></td>
                </tr>
                <tr>
                  <td style="width:100px"><p><b>対応人数</b></p></td>
                  <td><p>5 - 10人</p></td>
                </tr>
                <tr>
                  <td><p><b>遊び方</b></p></td>
                  <td style="text-align:left"><p>全員で同一の部屋に入室しゲーム始めて下さい。</p></td>
                </tr>
              </tbody>
              <router-link to="/rule" style="text-decoration:none;">
                <v-btn class="white--text send-button my-6" large tile color="#205020" max-width=190><b>詳しい説明へ</b></v-btn>
              </router-link>
            </template>
          <!-- </v-simple-table> -->
        </div>
      </v-card>
    </v-expand-transition>
  </div>
  <!-- </v-card> -->
</template>
<script>
export default {
  props: ['selected'],
  data() {
    return {
      changeHover: false
    }
  },
  methods:{
    pushed() {
      if (this.selected != 'description'){
        // this.selected = 'description'
        this.$emit("select-mode", {selected: "description"})
      }else {
        // this.selected = ''
        this.$emit("select-mode", {selected: ""})
      }
    },
    mouseover: function(){
      this.changeHover = true
    },
    mouseleave: function(){
      this.changeHover = false
    },
    openRule () {
    }
  }
}
</script>
<style>
#game-description td {
  /* background-color: rgba(0,0,0,0.1); */
  border-bottom: 4;
  padding: 4px 0;
}
#game-description p {
  color: #FFF;
}
</style>
